import { shallowEqual } from "react-redux";
import { useAppSelector } from "../hook";
/**
 * The Rulebook a chat HUD should render, resolved exactly like a turn (conversation → persona → character). Pure
 * selector — every input is hydrated elsewhere: the messages GET and the pin PATCH write `byConversationId`, the
 * persona GETs write `byPersonaId`, and `GET /v2/characters/{id}?include=rulebook` writes `byCharacterId`. An
 * untouched `byConversationId` key means the messages payload never ran, so the persona's or character's still shows.
 */
export default function useResolvedRulebook({ characterId, conversationId, personaId, }) {
    return useAppSelector((state) => {
        if (conversationId && conversationId in state.rulebook.byConversationId) {
            return {
                rulebook: state.rulebook.byConversationId[conversationId] ?? null,
                initialState: state.rulebook.initialStateByConversationId[conversationId] ?? null,
            };
        }
        if (personaId && state.rulebook.byPersonaId[personaId]) {
            return {
                rulebook: state.rulebook.byPersonaId[personaId] ?? null,
                initialState: state.rulebook.initialStateByPersonaId[personaId] ?? null,
            };
        }
        return {
            rulebook: characterId ? (state.rulebook.byCharacterId[characterId] ?? null) : null,
            initialState: characterId ? (state.rulebook.initialStateByCharacterId[characterId] ?? null) : null,
        };
    }, shallowEqual);
}
